import React from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  useTheme,
  useMediaQuery,
  makeStyles,
  DialogActions,
  Divider,
} from "@material-ui/core"
import TaskViewer from "./TaskViewer"
import { ProcessViewer, processVirtualStepMinimum } from "./ProcessViewer"
import { DialogTitleCloser } from "../Creators/DialogTitleCloser"
import { InlineTitleCloser } from "../Creators"
import { InlineTitle } from ".."
import { useMutationDeleteJob } from "../../data/jobs/useMutationUpdateJob"
import { RowBox } from "../Boxes"
import { DownloadExportJobButton } from "../Buttons"
import { hasExport as hasJobExport } from "../../utils"

const useStyles = makeStyles((theme) => ({
  actions: {
    justifyContent: "center",
  },
  mobileActions: {
    bottom: 0,
    position: "fixed",
    backgroundColor: "#ffffff",
    width: "100%",
    paddingBottom: 0,
    [theme.breakpoints.only("xs")]: {
      paddingBottom: theme.spacing(9),
    },
  },
  dialogPaper: {
    minHeight: ({ virtualSteps }) => (virtualSteps ? "calc(100vh - 64px)" : "auto"),
  },
}))

const JobViewer = ({ job, onClose, onDelete }) => {
  const theme = useTheme()
  const classes = useStyles({ virtualSteps: job?.status?.steps?.length > processVirtualStepMinimum })
  const [deleteJob] = useMutationDeleteJob(job)
  const isInline = useMediaQuery(theme.breakpoints.down("md"))
  const hasExport = hasJobExport(job)

  const handleClose = (event, isCancel) => {
    onClose(isCancel)
  }

  const handleDelete = async () => {
    await deleteJob({ variables: { id: job.id } })
    onDelete && onDelete()
  }

  if (!job) {
    return null
  }

  const display = (
    <>
      <Box mt={isInline ? 1 : 0} px={isInline ? 2 : 0} pb={hasExport ? 5 : 0} data-cy="JobViewer">
        {job && job.task && <TaskViewer job={job} onClose={handleClose} onDelete={handleDelete} isInline={isInline} />}
        {job && job.process && (
          <ProcessViewer
            job={job}
            onClose={handleClose}
            onDelete={handleDelete}
            isInline={isInline}
            scrollableTarget="JobViewer-content"
          />
        )}
      </Box>
    </>
  )

  if (isInline) {
    return (
      <>
        <InlineTitle>
          Job details
          <InlineTitleCloser onClose={handleClose} />
        </InlineTitle>
        {display}
        {hasExport && (
          <>
            <Box className={classes.mobileActions}>
              <Divider />
              <RowBox py={1} px={2} justifyContent="center">
                <DownloadExportJobButton job={job} />
              </RowBox>
            </Box>
          </>
        )}
      </>
    )
  }
  return (
    <Dialog
      open={job !== null}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      fullWidth
      maxWidth="md"
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle id="form-dialog-title">
        Job details
        <DialogTitleCloser onClose={handleClose} />
      </DialogTitle>
      <DialogContent id="JobViewer-content">{display}</DialogContent>
      {hasExport && (
        <>
          <Divider />
          <DialogActions className={classes.actions}>
            <Box className={classes.footer}>
              <DownloadExportJobButton job={job} />
            </Box>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

export { JobViewer }
